import React, { useState, useEffect } from 'react';

import FormField from '../../../FormField';

const ProjectName = ({ edit, name, handle_selected_name }) => {
  // const [nameValue, setName] = useState((name === null || name === 'null') ? 'Untitled' : name);
  // TO DO - handle change + handle errors
  const handleName = e => {
    // setName(e.target.value);
    handle_selected_name(e.target.value);
  };

  return (
    <>
      {edit ?
        <FormField label="Project Name" id="project_name">
          <input
            id="project_name"
            type="text"
            placeholder="Enter Project Name"
            // value={nameValue}
            value={name}
            onChange={handleName}
          />
        </FormField>
        // : <h2>{nameValue}</h2>}
        : <h2>{name}</h2>}
    </>
  )
}

export default ProjectName;